import { render, staticRenderFns } from "./NeighbourhoodMap.vue?vue&type=template&id=1c9fbfd8&scoped=true&"
import script from "./NeighbourhoodMap.vue?vue&type=script&lang=js&"
export * from "./NeighbourhoodMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9fbfd8",
  null
  
)

export default component.exports